import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebaseConfig';

const VerifyEmail = () => {
    const [verificationStatus, setVerificationStatus] = useState('checking');
    const navigate = useNavigate();

    useEffect(() => {
        const checkEmailVerification = async () => {
            try {
                const user = auth.currentUser;
                await user.reload();

                if (user.emailVerified) {
                    setVerificationStatus('verified');
                    setTimeout(() => navigate('/generate-map'), 3000);
                } else {
                    setVerificationStatus('pending');
                }
            } catch (error) {
                setVerificationStatus('error');
                console.error('Error checking verification:', error);
            }
        };

        checkEmailVerification();
    }, [navigate]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
                {verificationStatus === 'checking' && <p>Verificando seu email...</p>}
                {verificationStatus === 'verified' && <p>Email verificado! Redirecionando...</p>}
                {verificationStatus === 'pending' && <p>Por favor, verifique seu email para continuar.</p>}
                {verificationStatus === 'error' && <p>Erro na verificação. Tente novamente mais tarde.</p>}
            </div>
        </div>
    );
};

export default VerifyEmail;